// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1RLQJ","title":"InfoRow_title__Ebs6f"};